// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TysiaCopyToLocationsDialog from './data'

export default function TysiaCopyToLocationsDialogFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TysiaCopyToLocationsDialog">
      <TysiaCopyToLocationsDialog {...props}>
        {children}
      </TysiaCopyToLocationsDialog>
    </Flow>
  )
}
